<template>
    <div
        id="recipeCarousel"
        class="carousel slide carousel-fade"
        data-bs-ride="carousel"
    >
        <div class="carousel-inner">
            <div
                v-for="(recipe, key) in recipes"
                v-bind:key="recipe.id"
                :class="key == 0 ? 'active carousel-item' : 'carousel-item'"
            >
                <recipe-card
                    :recipe="recipe"
                    :show_category="true"
                ></recipe-card>
            </div>
        </div>
        <button
            class="carousel-control-prev"
            type="button"
            data-bs-target="#recipeCarousel"
            data-bs-slide="prev"
        >
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
        </button>
        <button
            class="carousel-control-next"
            type="button"
            data-bs-target="#recipeCarousel"
            data-bs-slide="next"
        >
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
        </button>
    </div>
</template>

<script>
import RecipeCard from "./RecipeCard.vue";
export default {
    components: { RecipeCard },
    name: "RecipeCarousel",
    props: ["recipes"],
    data() {
        return {};
    },
};
</script>
<style scoped></style>
